import { DefaultCardView } from './CardViews/DefaultCardView'
import { ExpandedCardView } from './CardViews/ExpandedCardView'
import { ExpandedLargeAvatarCardView } from './CardViews/ExpandedLargeAvatarCardView'
import { ExpandedSmallAvatarCardView } from './CardViews/ExpandedSmallAvatarCardView'
import { SplitPaneCardView } from './CardViews/SplitPaneCardView'
import { CardViewProps } from './cardViewTypes'

export const CardViewComponent = (props: CardViewProps) => {
  const layout = props.cardStyle.layout

  switch (layout) {
    case 'expanded':
      return <ExpandedCardView {...props} />
    case 'expandedLargeAvatar':
      return <ExpandedLargeAvatarCardView {...props} />
    case 'expandedSmallAvatar':
      return <ExpandedSmallAvatarCardView {...props} />
    case 'splitPane':
      return <SplitPaneCardView {...props} />
    default:
      return <DefaultCardView {...props} />
  }
}
